import * as React from 'react';
import { useState } from 'react';
import { rebrand } from '../../../../theme/color';
import { IconListItem } from '../../atoms/IconListItem';
import { Tooltip } from '../../atoms/Tooltip';
import { CreditPlanTypes } from '../../utilities/types';
import { styles } from './styles';
import { classes } from 'typestyle';
import { IconList } from '../../atoms/IconList';
import { CloseCross } from '../../atoms/icons/CloseCross';
import { tooltipStyles } from '../../../../styles/tooltipStyles';

// Colour used for iconlist icons
const ICON_COLOR = rebrand.secondary[60].toString();

export const EnterprisePlanFeatures: React.FC = () => (
  <IconList className={styles.iconList}>
    <IconListItem iconColor={ICON_COLOR}>Exclusive licensing deals</IconListItem>
    <IconListItem iconColor={ICON_COLOR}>Branded content licensing</IconListItem>
    <IconListItem iconColor={ICON_COLOR}>Music selection support</IconListItem>
    <IconListItem iconColor={ICON_COLOR}>Partnership opportunities</IconListItem>
    <IconListItem iconColor={ICON_COLOR}>Personalised support</IconListItem>
  </IconList>
);

interface PlanCardTooltipProps {
  tooltipText: React.ReactNode;
  text: React.ReactNode;
}

export const PlanCardTooltip: React.FC<PlanCardTooltipProps> = ({ tooltipText, text }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const tooltipContent = (
    <span className={tooltipStyles.tooltipInner}>
      {tooltipText}
      <button className={tooltipStyles.tooltipCloseBtn} onClick={() => setShowTooltip(false)}>
        <CloseCross color="inherit" size={16} />
      </button>
    </span>
  );

  return (
    <p className={styles.smallText}>
      <Tooltip
        className={tooltipStyles.tooltip}
        positions={['bottom', 'top']}
        show={showTooltip}
        onClickOutside={() => setShowTooltip(false)}
        disableOnMobile={false}
        content={tooltipContent}
      >
        <button className={classes(tooltipStyles.tooltipBtn, 'center')} onClick={() => setShowTooltip((val) => !val)}>
          {text}
        </button>
      </Tooltip>
    </p>
  );
};

export const MoneyBackGuarantee: React.FC = () => {
  const popupContent = (
    <>
      <sup>*</sup>If you don&apos;t use a premium track credit in the first month of your subscription, you can apply
      for a full refund
    </>
  );
  const textContent = (
    <>
      Money back guarantee<sup>*</sup>
    </>
  );

  return <PlanCardTooltip tooltipText={popupContent} text={textContent} />;
};

export const TrialPlanTooltip: React.FC = () => {
  const popupContent = (
    <>
      You will automatically be upgraded to the Starter plan once your trial is over, unless you cancel. You can cancel
      anytime during your 7 day trial for free.
    </>
  );

  const textContent = (
    <>
      Billing will start in 7 days unless canceled<sup>*</sup>
    </>
  );

  return <PlanCardTooltip tooltipText={popupContent} text={textContent} />;
};

// V2 PLAN PLACEHOLDERS //
export interface PlanPlaceholder {
  name: CreditPlanTypes;
  premiumCredits: number;
}

export const placeholderPlans: PlanPlaceholder[] = [
  {
    name: CreditPlanTypes.STARTER,
    premiumCredits: 1,
  },
  {
    name: CreditPlanTypes.PLUS,
    premiumCredits: 2,
  },
  {
    name: CreditPlanTypes.PRO,
    premiumCredits: 4,
  },
];
